import { useNavigate } from 'react-router'
import { observer } from 'mobx-react-lite'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { Badge, Box, Typography } from '@mui/material'
import { IconButton } from '@/components'
import { ROUTES } from '@/constants'
import { useStores } from '@/stores'
import { styles } from './styles'

export const User = observer(() => {
  const { appStore, profileStore } = useStores()
  const navigate = useNavigate()

  const handleNotificationsClick = () => {
    navigate(ROUTES.notifications)
  }

  return (
    <>
      <Box sx={styles.buttonsWrapper}>
        <Typography variant="body1">{`${profileStore?.student?.firstName} ${profileStore?.student?.lastName}`}</Typography>

        <Badge badgeContent={appStore.notificationCount} color="error">
          <IconButton onClick={handleNotificationsClick}>
            <NotificationsIcon />
          </IconButton>
        </Badge>
      </Box>
    </>
  )
})
